import { put, select } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'MERCHANT/TILES/LIST';
export const { actionTypes, actions, reducer } = new EasyRedux(key);

// The tiles use the same API as the sliders, But they have different types:
// type=2 -> sliders
// type=3 -> tiles

export function* watchGetTilesList(
  client,
  { payload: { siteId, resolve, reject } }
) {
  try {
    const userSiteId = yield select((state) => state?.userSite?.data?._id);
    const response = yield client.post('/merchant/slider/list', {
      data: { site: siteId || userSiteId, type: 3 },
    });
    yield put(actions.loadSuccess(response.result));
    resolve && resolve(response.result);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
